module.exports = __webpack_public_path__ + "static/SE_Logo_Text-7e74ce1257d4060003f8a5c7f2cb6e29.png";